<div class="row split-panel-container full-height">
    <cr-receiver-list #list (deleteRow)="openDeleteModal($event)" (showDetails)="openEditModal($event)"></cr-receiver-list>
    <receiver-edit-modal #editModal (onUpdateSaved)="getAllReceivers($event)"></receiver-edit-modal>
    <receiver-delete-modal #deleteModal (onDeleted)="getAllReceivers($event)"></receiver-delete-modal>
</div>